import { API, APICOBRANZA } from "../Constants/ApiConnection";
import axios from "axios";
import { toast } from "react-toastify";

export const getObtenerCobradores = async (user, values) => {
  let url = APICOBRANZA + "personal/obtenerCobradores";
  try {
    const response = await axios.get(url, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};

export const postAgregarEliminarCobrador = async (user, values) => {
  let url = APICOBRANZA + "personal/agregarEliminarCobrador";

  try {
    const response = await axios.post(url, values, {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
        "Access-Control-Allow-Headers": "*",
        "x-access-token": user.accessToken,
        maxBodyLength: Infinity,
      },
    });
    if (response.status === 200) {
      return response;
    }
  } catch (error) {
    console.error(error);
    return error;
  }
};
